import React from "react";
import {Input} from "reactstrap";

import {getEnv} from "../../env";
import {callApi} from "../../05-utils/commonUtils";

export default class FileUploader extends React.Component {
  async onFileSelect(files) {
    const file = files[0];

    if (!file) return;

    const lastIndexOf = file.name.lastIndexOf(".");

    const ext = file.name.substring(lastIndexOf + 1);

    const {presigned, uri} = await new Promise((resolve) =>
      callApi(
        getEnv("API_SERVER") + `/presigned?extensions=${JSON.stringify([ext])}`,
        {method: "post"},
        null,
        (data) => {
          resolve(data[0]);
        },
      ),
    );

    //-- put to presign and return tmp
    await fetch(presigned, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    this.props.onChange(uri);
  }

  render() {
    return (
      <Input
        type="file"
        onChange={(e) => this.onFileSelect(e.target.files)}
        accept="image/*"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/03-components/FileUploader/index.js